var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "carrier-service-rate-dropdown" },
    [
      _c(
        "md-menu",
        {
          attrs: {
            "md-direction": "bottom-start",
            "md-align-trigger": "",
            "md-active": _vm.toggleMenu,
          },
          on: {
            "update:mdActive": function ($event) {
              _vm.toggleMenu = $event
            },
            "update:md-active": function ($event) {
              _vm.toggleMenu = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "menu-trigger",
              attrs: { tabindex: "0", role: "button" },
              on: {
                click: _vm.openMenu,
                keydown: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.openMenu($event)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar",
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.openMenu($event)
                  },
                ],
              },
            },
            [
              _vm.selectedRate
                ? [
                    _c("img", {
                      staticClass: "carrier-logo",
                      attrs: {
                        src: _vm.selectedRate.carrierLogoUrl,
                        alt: _vm.selectedRate.carrierName,
                      },
                    }),
                    _c("div", { staticClass: "carrier-info" }, [
                      _c("div", { staticClass: "carrier-name" }, [
                        _vm._v(
                          _vm._s(_vm.selectedRate.carrierName) +
                            " " +
                            _vm._s(_vm.selectedRate.serviceName)
                        ),
                      ]),
                      _vm.selectedRate.amount > 0
                        ? _c(
                            "div",
                            { staticClass: "carrier-details" },
                            [
                              _c("span", { staticClass: "carrier-amount" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.formatAmount(
                                        _vm.selectedRate.amount,
                                        _vm.selectedRate.currency || "$"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]),
                              _vm.selectedRate.estimatedDeliveryTime
                                ? [
                                    _c("span", { staticClass: "carrier-dot" }, [
                                      _vm._v("•"),
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "carrier-time" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.selectedRate
                                              .estimatedDeliveryTime
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]),
                  ]
                : [_c("span", [_vm._v("Select a carrier service")])],
            ],
            2
          ),
          _c(
            "md-menu-content",
            [
              _c(
                "md-list",
                [
                  _vm.choices.length === 0
                    ? _c(
                        "md-list-item",
                        { staticClass: "no-choices", attrs: { disabled: "" } },
                        [
                          _vm._v(
                            "\n                    No carrier services available\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._l(_vm.choices, function (rate) {
                    return _c(
                      "md-list-item",
                      {
                        key: rate.identifier,
                        class: {
                          selected:
                            _vm.selectedRate &&
                            _vm.selectedRate.identifier === rate.identifier,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.selectRate(rate)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "carrier-logo",
                          attrs: {
                            src: rate.carrierLogoUrl,
                            alt: rate.carrierName,
                          },
                        }),
                        _c("div", { staticClass: "carrier-info" }, [
                          _c("div", { staticClass: "carrier-name" }, [
                            _vm._v(
                              _vm._s(rate.carrierName) +
                                " " +
                                _vm._s(rate.serviceName)
                            ),
                          ]),
                          rate.amount > 0
                            ? _c(
                                "div",
                                { staticClass: "carrier-details" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "carrier-amount" },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.formatAmount(
                                              rate.amount,
                                              rate.currency || "$"
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                  rate.estimatedDeliveryTime
                                    ? [
                                        _c(
                                          "span",
                                          { staticClass: "carrier-dot" },
                                          [_vm._v("•")]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "carrier-time" },
                                          [
                                            _vm._v(
                                              _vm._s(rate.estimatedDeliveryTime)
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }